module.exports = __webpack_public_path__ + "img/App_Store.2928664f.svg";